import { AgreementApproveResponse } from '@libs/api-reference';
import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type UseApproveAgreementOptions = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onSuccess?: UseMutationConfig<AgreementApproveResponse>['onSuccess'];
  onReject?: UseMutationConfig<AgreementApproveResponse>['onReject'];
};

export default function useApproveAgreement({
  onSuccess,
  onReject,
}: UseApproveAgreementOptions) {
  const {
    execute: approveAgreement,
    isPending: isLoadingApproveAgreement,
    ...query
  } = useMutation<AgreementApproveResponse>(API.approveAgreement, {
    onSuccess,
    onReject,
  });

  return { approveAgreement, isLoadingApproveAgreement, ...query };
}
